'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.noopResponse = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _network = require('helpers/network');

var _consoleColor = require('helpers/console-color');

var _responseCodes = require('helpers/responseCodes');

var _responseCodes2 = _interopRequireDefault(_responseCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methods = ['get', 'post', 'put', 'patch', 'del'];

var noopResponse = exports.noopResponse = { promise: null, request: null };

function formatUrl(path) {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  var adjustedPath = path[0] !== '/' ? '/' + path : path;
  var isDevApi = path.indexOf('/dev/') === 0;
  if (isDevApi) {
    adjustedPath = adjustedPath.replace('/dev/', '/');
  }

  if (__SERVER__ || !_config2.default.useApiProxy) {
    // Prepend host and port of the API server to the path.
    if (isDevApi) {
      return 'http://' + _config2.default.devApiHost + ':' + _config2.default.devApiPort + adjustedPath;
    }
    return _config2.default.apiProtocol + '://' + _config2.default.apiHost + ':' + _config2.default.apiPort + _config2.default.apiRoot + adjustedPath;
  }
  // Prepend `/api` to relative URL, to proxy to API server.
  if (isDevApi) {
    return '/dev/api' + adjustedPath;
  }
  return '/api' + adjustedPath;
}

function setServerHeaders(_ref) {
  var clientRequest = _ref.clientRequest,
      apiRequest = _ref.apiRequest;

  if (!__SERVER__) {
    return false;
  }

  apiRequest.set('X-CLIENT-IP', (0, _network.getClientIp)(clientRequest));

  var cookie = clientRequest.get('cookie');
  if (cookie) {
    apiRequest.set('cookie', cookie);
  }

  var ua = clientRequest.get('user-agent');
  if (ua) {
    apiRequest.set('User-Agent', ua);
  }
}

function setResponse(_ref2) {
  var err = _ref2.err,
      res = _ref2.res,
      hideErrors = _ref2.hideErrors,
      _ref2$hideErrorCodes = _ref2.hideErrorCodes,
      hideErrorCodes = _ref2$hideErrorCodes === undefined ? [] : _ref2$hideErrorCodes,
      reject = _ref2.reject,
      resolve = _ref2.resolve,
      response = _ref2.response,
      _ref2$successCodes = _ref2.successCodes,
      successCodes = _ref2$successCodes === undefined ? [_responseCodes2.default.success] : _ref2$successCodes;
  var _config$response = _config2.default.response,
      statusField = _config$response.statusField,
      messageField = _config$response.messageField;

  var isHasRespData = (0, _get3.default)(res, 'body');
  var respCode = (0, _get3.default)(res, ['body', statusField]);
  var isSuccessCode = [_responseCodes2.default.success].concat((0, _toConsumableArray3.default)(successCodes)).includes(respCode);
  var isError = err || isHasRespData && !isSuccessCode;

  var errResp = isError ? res.body || err : null;

  if (errResp) {
    if ((typeof errResp === 'undefined' ? 'undefined' : (0, _typeof3.default)(errResp)) !== 'object') {
      errResp = (0, _defineProperty3.default)({}, messageField, errResp);
    }
    errResp.hideErrors = hideErrors;
    errResp.hideErrorCodes = hideErrorCodes;
  }
  return errResp ? reject(errResp) : resolve(response);
}

var ApiClient = function () {
  function ApiClient(clientRequest) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ApiClient);

    methods.forEach(function (method) {
      return (
        // this[method] = (path, {params, data, raw, withStatus, json, hideErrors} = {}) => new Promise((resolve, reject) => {
        _this[method] = function (path) {
          var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              params = _ref3.params,
              data = _ref3.data,
              hideErrors = _ref3.hideErrors,
              _ref3$hideErrorCodes = _ref3.hideErrorCodes,
              hideErrorCodes = _ref3$hideErrorCodes === undefined ? [] : _ref3$hideErrorCodes,
              json = _ref3.json,
              successCodes = _ref3.successCodes;

          var apiRequest = _superagent2.default[method](formatUrl(path));

          var promise = new _promise2.default(function (resolve, reject) {
            console.log((0, _consoleColor.shellFg)('green') + 'API request: ' + method.toUpperCase() + ' ' + formatUrl(path) + (0, _consoleColor.shellReset)());

            apiRequest.withCredentials();

            if (!json) {
              // set the Content-Type to application/x-www-form-urlencoded
              apiRequest.type('form');
            }

            setServerHeaders({ clientRequest: clientRequest, apiRequest: apiRequest });

            if (params) {
              apiRequest.query(params);
            }

            if (data) {
              apiRequest.send(data);
            }

            // should be here to have ability to use .on handler in components. In other case if .on after .end - handler never be triggered
            apiRequest.on('progress', _noop3.default);

            apiRequest.end(function (err) {
              var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return setResponse({ err: err, res: res, hideErrors: hideErrors, hideErrorCodes: hideErrorCodes, successCodes: successCodes, reject: reject, resolve: resolve, response: res.body });
            });
          });

          return { promise: promise, request: apiRequest };
        }
      );
    });
  }
  /*
   * There's a V8 bug where, when using Babel, exporting classes with only
   * constructors sometimes fails. Until it's patched, this is a solution to
   * "ApiClient is not defined" from issue #14.
   * https://github.com/erikras/react-redux-universal-hot-example/issues/14
   *
   * Relevant Babel bug (but they claim it's V8): https://phabricator.babeljs.io/T2455
   *
   * Remove it at your own risk.
   */


  (0, _createClass3.default)(ApiClient, [{
    key: 'empty',
    value: function empty() {}
  }]);
  return ApiClient;
}();

exports.default = ApiClient;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ApiClient.js
// module id = 866
// module chunks = 1